import React, {useEffect, useState} from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { Form, Button, InputGroup, ButtonGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import moment from "moment";
import { useTranslation } from "react-i18next";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import bonus1 from "../assets/images/bonus-1.webp";
import bonus2 from "../assets/images/bonus-2.webp";
import bonus3 from "../assets/images/bonus-3.webp";
import bonus4 from "../assets/images/bonus-4.webp";

import top1 from "../assets/images/top-1.webp";
import top2 from "../assets/images/top-2.webp";
import top3 from "../assets/images/top-3.webp";
import income from "../assets/images/income.webp";
import { FaWhatsapp } from "react-icons/fa";
import SidebarLayout from "../components/shared/SidebarLayout";

import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  XIcon,
} from "react-share";
import { BiSolidRightArrow } from "react-icons/bi";
import { AiTwotoneCalendar } from "react-icons/ai";
const InviteFriends = () => {
  const {
    formState: { errors },
  } = useForm({});
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");

  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const getProfileData = useContextSelector(AuthContext, (ctx) => ctx.getProfileData);
  const showDate = useContextSelector(AuthContext, (ctx) => ctx.showDate);
  const setShowDate = useContextSelector(AuthContext, (ctx) => ctx.setShowDate);

  function copy(text) {
    toast.success("Link Copied!");
    return window.navigator.clipboard.writeText(text);
  }
  const [filter, setFilter] = useState({
    betType: "betfair",
    status: "completed",
    fromPeriod: new Date(),
    toPeriod: new Date(),
    displayStart: moment(new Date()).format("MM/YY"),
    displayEnd: moment(new Date()).format("MM/YY"),
    page: 1,
    limit: 50,
  });

  return (
    <LayoutNew>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
        style={{ position: `absolute`, width: `0`, height: `0` }}
      >
        <defs>
          <symbol
            xlinkHref="http://www.w3.org/1999/xlink"
            viewBox="0 0 44 44"
            id="left"
          >
            <title>Operation Icons Copy 4</title>
            <defs>
              <path id="left_a" d="M-129-845h24v24h-24z"></path>
            </defs>
            <clipPath id="left_b">
              <use xlinkHref="#left_a" overflow="visible"></use>
            </clipPath>
            <g clipPath="url(#left_b)">
              <defs>
                <path id="left_c" d="M-903-949H947V996H-903z"></path>
              </defs>
              <clipPath id="left_d">
                <use xlinkHref="#left_c" overflow="visible"></use>
              </clipPath>
            </g>
            <path d="M16.247 21.399L28.48 9.166l2.121 2.121-10.118 10.119 10.118 10.118-2.121 2.121-12.233-12.233.007-.006z"></path>
          </symbol>
          <symbol
            xlinkHref="http://www.w3.org/1999/xlink"
            viewBox="0 0 1024 1024"
            id="nodata_f4c19c2d"
            class="icon"
          >
            <defs>
              <style type="text/css"></style>
            </defs>
            <path
              d="M241.9712 227.45088a13.27104 13.27104 0 0 0 6.71744 11.776 13.70112 13.70112 0 0 0 13.45536 0 12.9024 12.9024 0 0 0 6.71744-11.776 13.29152 13.29152 0 0 0-13.45536-13.45536 13.7216 13.7216 0 0 0-13.43488 13.45536zM955.98592 394.6496s-9.74848 32.62464-28.91776 37.33504c0 0 24.22784 9.74848 28.91776 33.62816 0 0 3.70688-34.97984 31.27296-35.65568 0.02048 0-29.92128-16.13824-31.27296-35.30752zM1004.76928 341.17632s-3.70688 12.45184-11.10016 14.1312c0 0 9.07264 3.70688 11.10016 12.77952 0 0 1.35168-13.12768 11.776-13.12768 0-0.32768-11.44832-6.79936-11.776-13.78304zM18.55488 451.39968s-3.70688 12.45184-11.10016 14.1312c0 0 9.07264 3.70688 11.10016 12.77952 0 0 1.35168-13.12768 11.776-13.12768 0 0-11.42784-6.43072-11.776-13.78304zM720.896 160.84992a19.16928 19.16928 0 1 0 19.16928 19.16928 18.944 18.944 0 0 0-19.16928-19.16928z"
              p-id="32837"
              fill="#1296db"
            ></path>
            <path
              d="M720.896 194.1504a14.45888 14.45888 0 0 1 0-28.91776 14.56128 14.56128 0 0 1 14.45888 14.45888A14.336 14.336 0 0 1 720.896 194.1504zM141.0048 489.0624a19.16928 19.16928 0 1 0 19.16928 19.16928 18.944 18.944 0 0 0-19.16928-19.16928z"
              p-id="32838"
              fill="#1296db"
            ></path>
            <path
              d="M141.0048 522.36288a14.45888 14.45888 0 0 1 0-28.91776 14.56128 14.56128 0 0 1 14.45888 14.45888 14.336 14.336 0 0 1-14.45888 14.45888zM397.312 99.81952s-7.0656 24.8832-22.20032 28.672c0 0 18.16576 7.0656 22.20032 25.9072 0 0 3.03104-26.91072 23.87968-27.2384 0.32768-0.18432-23.22432-12.47232-23.87968-27.3408zM131.91168 372.736s-7.0656 24.8832-22.20032 28.672c0 0 18.16576 7.0656 22.20032 25.9072 0 0 3.03104-26.91072 23.87968-27.2384 0.34816-0.14336-23.20384-12.24704-23.87968-27.3408zM285.63456 892.416h-11.776v-138.24l11.776-1.35168v139.59168zM288.31744 742.4l-11.42784-3.70688 23.87968-71.31136c11.10016-32.62464 21.87264-65.24928 32.62464-97.87392l11.42784 3.70688c-11.10016 32.62464-21.87264 65.24928-32.62464 97.87392z"
              p-id="32839"
              fill="#1296db"
            ></path>
            <path
              d="M273.85856 754.176c-0.32768-5.38624 1.35168-10.09664 2.3552-14.45888l0.32768-1.35168 11.42784 3.70688-0.32768 1.35168a25.00608 25.00608 0 0 0-2.048 9.4208z m19.16928 159.744c-4.38272 0-9.74848-0.32768-14.1312-4.7104-5.03808-4.7104-5.03808-11.42784-5.03808-16.13824v-0.67584h12.10368v0.67584c0 3.03104 0 6.144 1.35168 7.0656l0.32768 0.32768c1.35168 1.35168 4.38272 1.35168 7.0656 1.35168h426.51648a13.9264 13.9264 0 0 0 4.7104-0.67584l0.32768-0.32768a12.12416 12.12416 0 0 0 1.35168-4.38272v-141.57824a34.59072 34.59072 0 0 0-0.32768-6.144c-7.74144-23.20384-15.81056-46.75584-23.20384-69.95968-11.85792-35.2256-23.22432-70.49216-35.34848-105.53344a5.03808 5.03808 0 0 0-4.7104-3.70688H354.59072a38.62528 38.62528 0 0 0-6.38976 0.32768 5.34528 5.34528 0 0 0-3.03104 3.03104l-11.34592-3.6864a16.4864 16.4864 0 0 1 11.42784-11.10016 47.65696 47.65696 0 0 1 9.4208-0.67584h308.69504a16.54784 16.54784 0 0 1 16.13824 11.776c11.776 35.30752 23.20384 70.63552 35.30752 105.61536 7.74144 23.20384 15.81056 46.75584 23.20384 69.95968v0.32768a49.2544 49.2544 0 0 1 0.67584 9.74848v140.94336c0 6.144-1.67936 10.09664-5.03808 13.12768a18.0224 18.0224 0 0 1-13.12768 4.7104l-427.52 0.32768z"
              p-id="32840"
              fill="#1296db"
            ></path>
            <path
              d="M506.28608 827.84256a66.02752 66.02752 0 0 1-38.33856-12.45184 65.08544 65.08544 0 0 1-26.91072-48.76288c0-1.67936-0.32768-5.03808-1.35168-6.144l-0.32768-0.32768a9.23648 9.23648 0 0 0-4.38272-0.67584h-131.52256a6.144 6.144 0 1 1 0-12.10368h131.85024a17.03936 17.03936 0 0 1 12.77952 4.38272c5.03808 4.38272 5.38624 11.10016 5.38624 14.45888a52.57216 52.57216 0 0 0 21.87264 39.69024 53.88288 53.88288 0 0 0 33.97632 10.09664 50.70848 50.70848 0 0 0 37.00736-17.8176 52.67456 52.67456 0 0 0 13.12768-32.62464c0-3.03104 0.32768-9.07264 5.03808-13.12768 3.70688-4.38272 9.4208-4.7104 13.12768-5.03808h131.85024a6.144 6.144 0 1 1 0 12.10368h-131.54304c-3.03104 0-4.38272 0.32768-4.7104 0.67584l-0.32768 0.32768a10.9568 10.9568 0 0 0-1.35168 4.7104 62.34112 62.34112 0 0 1-16.13824 40.36608A65.536 65.536 0 0 1 509.952 827.84256c-1.67936-0.67584-2.3552 0-3.70688 0z m125.46048-502.84544l60.2112 27.2384 99.2256-78.0288-75.34592 81.408 75.34592 25.23136 41.71776-152.3712z m83.41504 49.43872l-4.096 46.08 25.9072-33.97632zM467.92704 613.90848c-15.4624 8.41728-26.91072 13.12768-26.91072 13.12768l2.3552 6.71744a237.09696 237.09696 0 0 0 27.66848-13.45536z m33.97632-22.87616a264.04864 264.04864 0 0 1-22.20032 15.81056 3.6864 3.6864 0 1 0 3.70688 6.38976c8.06912-5.03808 15.81056-10.77248 22.87616-16.13824a3.8912 3.8912 0 0 0 1.35168-3.35872c0-1.35168-1.35168-2.3552-2.048-3.03104a4.62848 4.62848 0 0 0-3.6864 0.34816z m39.0144-37.33504a3.6864 3.6864 0 0 0-5.03808 0.67584 173.28128 173.28128 0 0 1-20.84864 24.22784 3.56352 3.56352 0 0 0 5.03808 5.03808 154.66496 154.66496 0 0 0 21.87264-25.55904 2.94912 2.94912 0 0 0 0.32768-2.3552c0.32768-0.32768-0.32768-1.35168-1.35168-2.048z m16.81408-77.70112a3.23584 3.23584 0 0 0 2.048 3.03104 4.77184 4.77184 0 0 0 3.70688-0.32768 3.8912 3.8912 0 0 0 1.35168-3.35872c-1.67936-16.13824-7.74144-28.672-17.16224-36.6592a4.096 4.096 0 0 0-5.03808 0.32768 3.3792 3.3792 0 0 0 0.32768 5.03808c8.41728 6.38976 13.45536 17.48992 14.80704 31.9488z m-58.85952-35.98336a4.5056 4.5056 0 0 0 1.67936-0.32768 45.75232 45.75232 0 0 1 29.5936-3.03104 3.72736 3.72736 0 1 0 2.3552-7.0656 50.66752 50.66752 0 0 0-34.304 3.03104 3.66592 3.66592 0 0 0-2.048 4.38272 2.72384 2.72384 0 0 0 2.72384 3.01056z m-19.51744 36.33152a27.48416 27.48416 0 0 1-0.32768-9.07264l3.35872-11.10016a44.93312 44.93312 0 0 1 5.38624-7.74144 3.56352 3.56352 0 0 0-5.03808-5.03808 36.864 36.864 0 0 0-10.09664 34.97984 3.19488 3.19488 0 0 0 4.38272 2.3552 3.54304 3.54304 0 0 0 2.3552-4.38272z m1.00352 12.77952a3.39968 3.39968 0 0 0-0.67584 5.03808 93.42976 93.42976 0 0 0 14.80704 16.13824c2.048 1.67936 4.7104 3.70688 6.71744 5.38624a3.60448 3.60448 0 0 0 4.38272-5.71392l-6.38976-5.03808a77.824 77.824 0 0 1-13.45536-14.80704 3.62496 3.62496 0 0 0-5.36576-1.00352z m56.85248 40.96a3.3792 3.3792 0 0 0 3.35872-3.35872 3.93216 3.93216 0 0 0-3.03104-3.70688 64.67584 64.67584 0 0 1-21.1968-6.71744 3.54304 3.54304 0 1 0-3.03104 6.38976A89.68192 89.68192 0 0 0 536.576 530.432l0.67584-0.32768z m27.2384-8.74496a21.74976 21.74976 0 0 0-4.38272 1.35168 140.88192 140.88192 0 0 0 5.03808-25.9072 6.144 6.144 0 0 0-0.67584-2.3552 3.39968 3.39968 0 0 0-2.3552-1.35168 3.46112 3.46112 0 0 0-3.70688 3.35872 86.30272 86.30272 0 0 1-6.144 27.58656 19.16928 19.16928 0 0 0-4.38272 0.32768 3.3792 3.3792 0 0 0-3.35872 3.35872 3.46112 3.46112 0 0 0 3.70688 3.35872h1.35168c-1.35168 3.35872-3.03104 6.71744-4.7104 10.09664a3.87072 3.87072 0 0 0 1.67936 4.7104 3.72736 3.72736 0 0 0 4.7104-1.35168 130.84672 130.84672 0 0 0 6.38976-14.1312 87.92064 87.92064 0 0 0 9.07264-2.048 3.19488 3.19488 0 0 0 2.3552-4.38272 3.31776 3.31776 0 0 0-4.7104-2.68288z m42.37312-25.23136a143.03232 143.03232 0 0 1-24.8832 17.8176 3.6864 3.6864 0 1 0 3.70688 6.38976 153.74336 153.74336 0 0 0 26.23488-18.8416 5.14048 5.14048 0 0 0 1.35168-3.35872 2.82624 2.82624 0 0 0-2.3552-2.3552 4.096 4.096 0 0 0-4.03456 0.43008z m37.00736-35.98336a6.144 6.144 0 0 0-2.3552-0.67584 2.90816 2.90816 0 0 0-2.3552 1.35168 210.2272 210.2272 0 0 1-18.8416 22.20032 3.3792 3.3792 0 0 0 0.32768 5.03808 3.66592 3.66592 0 0 0 5.03808 0 274.7392 274.7392 0 0 0 19.16928-22.87616 6.144 6.144 0 0 0 0.67584-2.3552 4.62848 4.62848 0 0 0-1.67936-2.68288zM673.792 413.696a5.71392 5.71392 0 0 0-2.3552-0.32768c-0.67584 0.32768-1.67936 0.67584-2.048 1.67936A326.43072 326.43072 0 0 1 651.264 444.416a4.77184 4.77184 0 0 0-0.32768 3.70688 2.94912 2.94912 0 0 0 3.03104 2.048A3.72736 3.72736 0 0 0 657.408 448.512c6.38976-9.74848 12.77952-19.84512 18.8416-30.26944a5.7344 5.7344 0 0 0 0.32768-2.3552c-1.00352-1.00352-2.048-1.35168-2.68288-2.048z m22.87616-46.08a4.54656 4.54656 0 0 0-3.03104 0 2.99008 2.99008 0 0 0-2.048 2.048s-4.7104 11.10016-12.77952 27.2384a3.54304 3.54304 0 0 0 6.38976 3.03104c8.41728-16.13824 13.12768-27.2384 13.12768-27.58656a3.74784 3.74784 0 0 0-1.67936-4.7104z"
              p-id="32841"
              fill="#1296db"
            ></path>
          </symbol>
        </defs>
      </svg>
      <div className="invite-friends">
        <div className="invite-friends-root">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-inviteFriends mc-default-header am-navbar am-navbar-light"
            >
              <div
                className="am-navbar-left"
                role="button"
                onClick={() => navigate(-1)}
              >
                <span className="am-navbar-left-content">
                  <span className="return_icon">
                    <svg className="am-icon am-icon-left am-icon-lg">
                      <use xlinkHref="#left"></use>
                    </svg>
                  </span>
                </span>
              </div>
              <div className="am-navbar-title">Invite Friends</div>
              <div className="am-navbar-right"></div>
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace"></div>
          </div>
          <div className="am-tabs am-tabs-top invite-tab">
            <div role="tablist" className="am-tabs-bar" tabindex="0">
              <div className="am-tabs-nav-container am-tabs-nav-swipe-container am-tabs-nextpage">
                <div className="am-tabs-nav-wrap">
                  <div className="am-tabs-nav-swipe">
                    <div className="am-tabs-nav">
                      {/* <div
                        
                         className="am-tabs-ink-bar am-tabs-ink-bar-animated"
                        style={{
                          display: `block`,
                          transform: `translate3d(0px, 0px, 0px)`,
                          width: `103px`,
                        }}
                      ></div> */}
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="true"
                        className={
                          activeTab == "overview"
                            ? "am-tabs-tab am-tabs-tab-active"
                            : "am-tabs-tab"
                        }
                        style={{ flexBasis: `33.3333%;` }}
                        onClick={() => setActiveTab("overview")}
                      >
                        <span className="am-badge">Overview</span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className={
                          activeTab == "rewards"
                            ? "am-tabs-tab am-tabs-tab-active"
                            : "am-tabs-tab"
                        }
                        style={{ flexBasis: `33.3333%;` }}
                        onClick={() => setActiveTab("rewards")}
                      >
                        <span className="am-badge">Rewards</span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className={
                          activeTab == "incomes"
                            ? "am-tabs-tab am-tabs-tab-active"
                            : "am-tabs-tab"
                        }
                        style={{ flexBasis: `33.3333%;` }}
                        onClick={() => setActiveTab("incomes")}
                      >
                        <span className="am-badge">Incomes</span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className={
                          activeTab == "records"
                            ? "am-tabs-tab am-tabs-tab-active"
                            : "am-tabs-tab"
                        }
                        style={{ flexBasis: `33.3333%;` }}
                        onClick={() => setActiveTab("records")}
                      >
                        <span className="am-badge">Records</span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className={
                          activeTab == "invitelist"
                            ? "am-tabs-tab am-tabs-tab-active"
                            : "am-tabs-tab"
                        }
                        style={{ flexBasis: `33.3333%;` }}
                        onClick={() => setActiveTab("invitelist")}
                      >
                        <span className="am-badge">Invitee List</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="am-tabs-content am-tabs-content-no-animated">
              {activeTab == "overview" && (
                <div
                  role="tabpanel"
                  aria-hidden="false"
                  className="am-tabs-tabpane am-tabs-tabpane-active"
                >
                  <div className="invite-friends-container">
                    <div className="container-wrap">
                      <div className="invite-friends-info">
                        <div className="info-item">
                          <div className="item-title">Today's Income</div>
                          <div className="amount-balance-common item-number">
                            <span className="currency ">৳</span>

                            <span className="number-mc undefined">0.00</span>
                          </div>
                        </div>
                        <div className="info-item">
                          <div className="item-title">Yesterday's Income</div>
                          <div className="amount-balance-common item-number">
                            <span className="currency ">৳</span>

                            <span className="number-mc undefined">0.00</span>
                          </div>
                        </div>
                        <div className="info-item">
                          <div className="item-title">Registers</div>
                          <div className="item-number">0</div>
                        </div>
                        <div className="info-item">
                          <div className="item-title">Valid Referral</div>
                          <div className="item-number">0</div>
                        </div>
                      </div>
                      <div className="invite-friends-link">
                        <div className="link-top-title">
                          Share to your friends
                        </div>
                        <div className="share-content-wrap">
                          <div className="share-title">
                            Share to your friends
                          </div>
                          <div className="share-group">
                            <div className="refer-share-button-inner">
                              <a
                                href={`https://web.whatsapp.com/send?text=https://ck75.live/register?referral_code=${profileData?.referalCode}`}
                                target="_blank"
                                style={{ marginRight: "5px" }}
                              >
                                {" "}
                                <FaWhatsapp color="green" size={26} />{" "}
                              </a>

                              <FacebookShareButton
                                style={{ marginRight: "5px" }}
                                url={`https://ck75.live/register?referral_code=${profileData?.referalCode}`}
                              >
                                <FacebookIcon size={26} round />
                              </FacebookShareButton>
                              <TwitterShareButton
                                url={`https://ck75.live/register?referral_code=${profileData?.referalCode}`}
                                style={{ marginRight: "5px" }}
                              >
                                <XIcon size={26} round />
                              </TwitterShareButton>
                              <TelegramShareButton
                                url={`https://ck75.live/register?referral_code=${profileData?.referalCode}`}
                              >
                                <TelegramIcon size={26} round />
                              </TelegramShareButton>
                            </div>
                          </div>
                        </div>
                        <div className="invite-link-wrap">
                          <svg className="am-icon am-icon-share-link_b24bce29 am-icon-md">
                            <use xlinkHref="#share-link_b24bce29"></use>
                          </svg>
                          <div className="link-url">
                            https://ck75.live/register?referral_code=
                            {profileData?.referalCode}
                          </div>
                          <div className="link-copy">
                            <span
                              onClick={() => {
                                copy(
                                  `${window.location.origin}/register?referral_code=${profileData?.referalCode}`
                                );
                              }}
                            >
                              Copy
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="invite-friends-how">
                        <div className="default-title">
                          Invite 1 person and earn up to 1000TK
                        </div>
                        <div className="info-content">
                          <div className="wysiwyg">
                            <p style={{ textAlign: `center` }}>
                              <span style={{ color: `#f39c12` }}>
                                <span style={{ fontSize: `0.28rem` }}>
                                  <strong>Earn </strong>
                                </span>
                              </span>
                              <span style={{ color: `#c0392b` }}>
                                <span style={{ fontSize: `0.28rem` }}>
                                  <strong>2.2%</strong>
                                </span>
                              </span>
                              <span style={{ color: `#f39c12` }}>
                                <span style={{ fontSize: `0.28rem` }}>
                                  <strong> on lower level deposits</strong>
                                </span>
                              </span>
                            </p>
                            <p style={{ textAlign: `center` }}>
                              <span style={{ color: `#f39c12` }}>
                                <span style={{ fontSize: `0.28rem` }}>
                                  <strong>Lower level earns </strong>
                                </span>
                              </span>
                              <span style={{ color: `#c0392b` }}>
                                <span style={{ fontSize: `0.28rem` }}>
                                  <strong>1%</strong>
                                </span>
                              </span>
                              <span style={{ color: `#f39c12` }}>
                                <span style={{ fontSize: `0.28rem` }}>
                                  <strong>
                                    <strong></strong>on every bet{" "}
                                  </strong>
                                </span>
                              </span>
                              <br /> &nbsp;
                            </p>
                            <hr />
                            <div align="center">
                              <div className="responsive-table tview">
                                <table
                                  style={{
                                    borderCollapse: `collapse`,
                                    width: `232.0500pt`,
                                    border: `1.0000pt solid #000000`,
                                  }}
                                >
                                  <tbody>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `1.0000pt solid #000000`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Inviter
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP level
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `1.0000pt solid #000000`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Referral bonus/person
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `1.0000pt solid #000000`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Recommend a friend request
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          width: `66.0000pt`,
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `1.0000pt solid #000000`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `66`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    How to get it?
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP0
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    100TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Deposit 100TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Bet 2000TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        rowspan="7"
                                        style={{
                                          width: `66.0000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `66`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Noon the next day
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Before 12 o'clock
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Automatic transfer to
                                                    account
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP1-2
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    150TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Deposit 100TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Bet 2000TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP3-5
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    200TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Deposit 100TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Bet 2000TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP6-8
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    300TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Golden EGG
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Deposit 200TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Bet 4000TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP9-18
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    400TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Golden EGG
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Deposit 300TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Bet 6000TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP18-25
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    700TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Golden EGG
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Deposit 500TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Bet 10000TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                    <tr style={{ height: `61.7500pt` }}>
                                      <td
                                        nowrap="nowrap"
                                        style={{
                                          borderLeft: `1.0000pt solid #000000`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    VIP26-30
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    1000TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Golden EGG
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                      <td
                                        style={{
                                          width: `55.6000pt`,
                                          borderLeft: `none`,
                                          borderRight: `1.0000pt solid #000000`,
                                          borderTop: `none`,
                                          borderBottom: `1.0000pt solid #000000`,
                                          background: `#ffffff`,
                                          width: `55`,
                                        }}
                                      >
                                        <p
                                          align="center"
                                          style={{
                                            textAlign: `center`,
                                            padding: `0.0000pt 5.4000pt 0.0000pt 5.4000pt`,
                                          }}
                                        >
                                          <span
                                            style={{ verticalAlign: `middle` }}
                                          >
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Deposit 500TK &amp;
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                            <br />
                                            <span
                                              style={{ fontSize: `9.0000pt` }}
                                            >
                                              <span
                                                style={{
                                                  fontFamily: `微软雅黑`,
                                                }}
                                              >
                                                <span
                                                  style={{ color: `#000000` }}
                                                >
                                                  <span
                                                    style={{
                                                      fontStyle: `normal`,
                                                    }}
                                                  >
                                                    Bet 10000TK
                                                  </span>
                                                </span>
                                              </span>
                                            </span>
                                          </span>
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="invite-friends-bonus">
                        <div className="default-title bonus-title">
                          Rewards Released to Date
                        </div>
                        <div className="bonus-item">
                          <div className="bonus-img">
                            <img src={bonus1} alt="goals" />
                          </div>
                          <div className="bonus-info">
                            <div className="info-title">Invitation Rewards</div>
                            <div className="amount-balance-common info-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">
                                31,387,986.00
                              </span>
                            </div>
                            <div className="info-detail">
                              <div className="detail-num">97061</div>
                              <div className="detail-desc">claimed</div>
                            </div>
                          </div>
                        </div>
                        <div className="bonus-item">
                          <div className="bonus-img">
                            <img src={bonus2} alt="goals" />
                          </div>
                          <div className="bonus-info">
                            <div className="info-title">
                              Achievement Rewards
                            </div>
                            <div className="amount-balance-common info-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">
                                705,140.00
                              </span>
                            </div>
                            <div className="info-detail">
                              <div className="detail-num">14162</div>
                              <div className="detail-desc">claimed</div>
                            </div>
                          </div>
                        </div>
                        <div className="bonus-item">
                          <div className="bonus-img">
                            <img src={bonus3} alt="goals" />
                          </div>
                          <div className="bonus-info">
                            <div className="info-title">Deposit Rebate</div>
                            <div className="amount-balance-common info-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">
                                22,605,177.14
                              </span>
                            </div>
                            <div className="info-detail">
                              <div className="detail-num">111206</div>
                              <div className="detail-desc">claimed</div>
                            </div>
                          </div>
                        </div>
                        <div className="bonus-item">
                          <div className="bonus-img">
                            <img src={bonus4} alt="goals" />
                          </div>
                          <div className="bonus-info">
                            <div className="info-title">Betting Rebate</div>
                            <div className="amount-balance-common info-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">
                                34,391,324.84
                              </span>
                            </div>
                            <div className="info-detail">
                              <div className="detail-num">125138</div>
                              <div className="detail-desc">claimed</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="leader-board">
                        <div>
                          <div className="default-title leader-title">
                            Leaderboard
                          </div>
                          <div className="board-content">
                            <div className="board-top">
                              <div className="top-item top2">
                                <div className="item-img">
                                  <img src={top2} alt="top2" />
                                </div>
                                <div className="item-name">01*****1</div>
                                <div className="amount-balance-common item-amount">
                                  <span className="currency ">৳</span>

                                  <span className="number-mc undefined">
                                    5,864,514.89
                                  </span>
                                </div>
                              </div>
                              <div className="top-item top1">
                                <div className="item-img">
                                  <img src={top1} alt="top2" />
                                </div>
                                <div className="item-name">01*****3</div>
                                <div className="amount-balance-common item-amount">
                                  <span className="currency ">৳</span>

                                  <span className="number-mc undefined">
                                    7,958,644.33
                                  </span>
                                </div>
                              </div>
                              <div className="top-item top3">
                                <div className="item-img">
                                  <img src={top3} alt="top2" />
                                </div>
                                <div className="item-name">01*****8</div>
                                <div className="amount-balance-common item-amount">
                                  <span className="currency ">৳</span>

                                  <span className="number-mc undefined">
                                    3,237,047.71
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="board-bottom">
                              <div className="list-title">
                                Who received the rewards
                              </div>
                              <div className="board-list">
                                <div
                                  className="swiper-container swiper-container-initialized swiper-container-vertical swiper-container-android"
                                  id="swiper-invite"
                                >
                                  <div className="swiper-wrapper">
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="16"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********6
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          300.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="17"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********6
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Golden Egg
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="18"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          200.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="19"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="0"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        13*******2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          300.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="1"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        13*******2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Golden Egg
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="2"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********5
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          150.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="3"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********5
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="4"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********6
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          150.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="5"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********6
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="6"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********9
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          150.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="7"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********9
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-prev"
                                      data-swiper-slide-index="8"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********4
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          200.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-active"
                                      data-swiper-slide-index="9"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********4
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-next"
                                      data-swiper-slide-index="10"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********8
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          150.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="11"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********8
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="12"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********0
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          200.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="13"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********0
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="14"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          300.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="15"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Golden Egg
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="16"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********6
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          300.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="17"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********6
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Golden Egg
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="18"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          200.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item"
                                      data-swiper-slide-index="19"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="0"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        13*******2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          300.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="1"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        13*******2
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Golden Egg
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="2"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********5
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="amount-balance-common item-amount">
                                        <span className="currency ">৳</span>

                                        <span className="number-mc undefined">
                                          150.00
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="swiper-slide list-item swiper-slide-duplicate"
                                      data-swiper-slide-index="3"
                                      style={{ height: `44px` }}
                                    >
                                      <div className="item-info">
                                        01********5
                                      </div>
                                      <div className="item-info">Received</div>
                                      <div className="item-amount">
                                        Free Spin Voucher
                                      </div>
                                    </div>
                                  </div>
                                  <span
                                    className="swiper-notification"
                                    aria-live="assertive"
                                    aria-atomic="true"
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="income-calculation">
                        <div className="income-top">
                          <img
                            className="income-img"
                            src={income}
                            alt="goals"
                          />
                          <div className="income-title">Income calculator</div>
                        </div>
                        <div className="income-info">
                          <div className="amount-wrap">
                            <div className="amount-balance-common item-amount">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">
                                1,000.00
                              </span>
                            </div>
                          </div>
                          <div className="amount-detail">
                            <div className="wysiwyg">
                              Invite <label>1</label> active users, expected
                              revenue{" "}
                            </div>
                          </div>
                          <div className="progress-bar-wrap">
                            <div className="am-slider-wrapper">
                              <div className="am-slider">
                                <div className="am-slider-rail"></div>
                                <div
                                  className="am-slider-track"
                                  style={{
                                    visibility: `visible`,
                                    left: `0%`,
                                    width: `0%`,
                                  }}
                                ></div>
                                <div className="am-slider-step"></div>
                                <div
                                  role="slider"
                                  aria-valuemin="1"
                                  aria-valuemax="7"
                                  aria-valuenow="1"
                                  aria-disabled="false"
                                  className="am-slider-handle"
                                  style={{ left: `0%` }}
                                ></div>
                                <div className="am-slider-mark"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="footer-wrap">
                        <div className="default-title"></div>
                        <div className="info-content">
                          <div className="wysiwyg"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab == "rewards" && (
                <div
                  role="tabpanel"
                  aria-hidden="true"
                  className="am-tabs-tabpane am-tabs-tabpane-inactive"
                >
                  <div className="invite-friends-rewards">
                    <div className="container-wrap">
                      <div className="rewards-time">
                        <div className="time-title">
                          <span className="time">No expiration</span>
                        </div>
                      </div>
                      <div className="rewards-list">
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 3 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">30.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">3</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 7 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">40.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">7</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 12 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">50.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">12</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 20 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">100.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">20</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 50 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">300.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">50</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 100 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">500.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">100</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 200 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">1,000.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">200</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 500 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">3,000.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">500</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 1000 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">5,000.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">1000</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 2000 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">10,000.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">2000</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 3000 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">15,000.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">3000</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                        <div className="rewards-item disable ">
                          <div className="item-content">
                            <div className="item-title">
                              Over 5000 valid referral in total.
                            </div>
                            <div className="item-info">
                              <svg className="am-icon am-icon-coin_a9a0c66b am-icon-md">
                                <use xlinkHref="#coin_a9a0c66b"></use>
                              </svg>
                              <div className="item-num">30,000.00</div>
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <div className="btn-info">
                              <div className="current">0</div>
                              <div className="goals">5000</div>
                            </div>
                            <div className="get-btn">Available</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab == "incomes" && (
                <div
                  role="tabpanel"
                  aria-hidden="true"
                  className="am-tabs-tabpane am-tabs-tabpane-inactive"
                >
                  <div className="invite-friends-income">
                    <div className="container-wrap">
                      <div className="income-wrap">
                        <div className="income-top hii">
                          <div className="income-title"></div>
                          <div className="amount-balance-common item-num">
                            <span className="currency ">৳</span>

                            <span className="number-mc undefined">0.00</span>
                          </div>
                        </div>
                        <div className="income-list">
                          <div className="list-item">
                            <div className="item-title">Invitation Rewards</div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">
                              Achievement Rewards
                            </div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Deposit Rebate</div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Betting Rebate</div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Registers</div>
                            <div className="item-num">0</div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Valid Referral</div>
                            <div className="item-num">0</div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Depositors</div>
                            <div className="item-num">0</div>
                          </div>
                        </div>
                        <div className="income-bottom">
                          <div className="info-wrap">
                            <div className="wysiwyg"></div>
                          </div>
                        </div>
                      </div>
                      <div className="income-wrap">
                        <div className="income-top">
                          <div className="income-title">Total Income</div>
                          <div className="amount-balance-common item-num">
                            <span className="currency ">৳</span>

                            <span className="number-mc undefined">0.00</span>
                          </div>
                        </div>
                        <div className="income-list">
                          <div className="list-item">
                            <div className="item-title">Invitation Rewards</div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">
                              Achievement Rewards
                            </div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Deposit Rebate</div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Betting Rebate</div>
                            <div className="amount-balance-common item-num">
                              <span className="currency ">৳</span>

                              <span className="number-mc undefined">0.00</span>
                            </div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Registers</div>
                            <div className="item-num">0</div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Valid Referral</div>
                            <div className="item-num">0</div>
                          </div>
                          <div className="list-item">
                            <div className="item-title">Depositors</div>
                            <div className="item-num">0</div>
                          </div>
                        </div>
                        <div className="income-bottom">
                          <div className="info-wrap">
                            <div className="wysiwyg"></div>
                          </div>
                        </div>
                      </div>
                      <div className="income-tip">
                        Note : The system updates the data every 15 minutes.
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab == "records" && (
                <div
                  role="tabpanel"
                  aria-hidden="true"
                  className="am-tabs-tabpane am-tabs-tabpane-inactive"
                >
                  <div className="invite-friends-records">
                    <div className="invite-search-wrap">
                      {/* <div className="select-item select-type  ">
                        <div className="select-text">Invitation Rewards</div>
                        <svg className="am-icon am-icon-arrow-down_90cec9b0 am-icon-md arrow">
                          <use xlinkHref="#arrow-down_90cec9b0"></use>
                        </svg>
                      </div> */}
                      <select id="depositType">
                        <option value="online" security="true">
                          Invitation Rewards
                        </option>
                      </select>
                      <div className="select-item select-date">
                        <div className="pl-filter">
                          <div className="pl-filter-first">
                            <div
                              onClick={() =>
                                setShowDate({ status: true, type: "Calendar" })
                              }
                              className="pl-filter-first-time"
                            >
                              <AiTwotoneCalendar />
                              <span className="text-white truncate">
                                {filter?.displayStart} - {filter?.displayEnd}
                              </span>
                            </div>
                            {/* <Button
                                      onClick={() => setShowDate({ status: true, type: "During" })}
                                    >
                                      ...
                                    </Button>
                                    <Button >{"Submit"}</Button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="search-result">
                      <div className="rewards-list">
                        <div className="list-header">
                          <div className="item-info">Registration date</div>
                          <div className="item-info">Username</div>
                          <div className="item-info">Amount</div>
                        </div>
                        <div
                          className="nodata-container"
                          style={{ height: `915px` }}
                        >
                          <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                            <use xlinkHref="#nodata_f4c19c2d"></use>
                          </svg>
                          <p className="">No data</p>
                        </div>
                        <div className="list-wrapper">
                          <ul className="scroll-inner-container">
                            <li></li>
                          </ul>
                          <div className="pullup-wrapper"></div>
                        </div>
                      </div>
                    </div>
                    <div className="invite-records-footer">
                      <div className="footer-title">Total</div>
                      <div className="footer-num">0.00</div>
                    </div>
                  </div>
                </div>
              )}
              {activeTab == "invitelist" && (
                <div class="invite-friends-list">
                  <div class="invite-search-wrap">
                    <div class="select-item select-status ">
                      <div class="select-text">All</div>
                      <svg class="am-icon am-icon-arrow-down_90cec9b0 am-icon-md arrow">
                        <use xlinkHref="#arrow-down_90cec9b0"></use>
                      </svg>
                    </div>
                    <a
                      role="button"
                      class="today-btn am-button am-button-primary am-button-small am-button-inline am-button-icon"
                      aria-disabled="false"
                    >
                      <svg
                        class="am-icon am-icon-check-circle-o am-icon-xxs"
                        aria-hidden="true"
                      >
                        <use xlinkHref="#check-circle-o"></use>
                      </svg>
                      <span>Today</span>
                    </a>
                    <div class="select-item select-date">
                      <div class="flex-shrink1 filter-time-btn">
                        <a
                          role="button"
                          class="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                          aria-disabled="false"
                        >
                          <svg
                            class="am-icon am-icon-calendar_c4db3b67 am-icon-xxs"
                            aria-hidden="true"
                          >
                            <use xlinkHref="#calendar_c4db3b67"></use>
                          </svg>
                          <span>06/23- 06/23</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="search-result">
                    <div class="friends-list">
                      <div class="nodata-container" >
                        <svg class="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                          <use xlinkHref="#nodata_f4c19c2d"></use>
                        </svg>
                        <p class="">No data</p>
                      </div>
                      <div
                        class="list-wrapper"
                       
                      >
                        <ul
                          class="scroll-inner-container"
                        >
                          <li></li>
                        </ul>
                        <div class="pullup-wrapper"></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </LayoutNew>
  );
};

export default InviteFriends;
